import React, { useEffect, useState, useCallback } from 'react';
import { Text, Group } from '@mantine/core';
import { createAssistantApi } from '../../../lib/api/domains/assistant';
import { apiRequest } from '../../../lib/api/http';

const assistantApi = createAssistantApi(apiRequest);

export interface KianRateLimitFooterProps {
  /** Nach jeder erfolgreichen Aktualisierung hochzählen */
  refreshToken?: number;
}

interface RateStatus {
  line: string;
  percentUsed: number;
}

export function KianRateLimitFooter({ refreshToken = 0 }: KianRateLimitFooterProps) {
  const [status, setStatus] = useState<RateStatus | null>(null);

  const fetchStatus = useCallback(async () => {
    try {
      const s = await assistantApi.getRateLimitStatus();
      const resetSec = Math.max(0, Math.ceil(s.resetInMs / 1000));
      const percentUsed = s.maxPerMin > 0 ? s.usedPerMin / s.maxPerMin : 0;
      setStatus({
        line: `Anfragen ${s.usedPerMin}/${s.maxPerMin} · Reset in ${resetSec}s`,
        percentUsed,
      });
    } catch {
      setStatus(null);
    }
  }, []);

  useEffect(() => {
    void fetchStatus();
    const id = window.setInterval(() => void fetchStatus(), 30_000);
    return () => window.clearInterval(id);
  }, [fetchStatus]);

  // refreshToken triggert explizit einen sofortigen Refresh (nach gesendetem Chat).
  const isFirst = React.useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    void fetchStatus();
  }, [refreshToken, fetchStatus]);

  // Nur anzeigen wenn Nutzung ≥80% — darunter ist der Footer einfach visual noise.
  if (!status || status.percentUsed < 0.8) return null;

  const isCritical = status.percentUsed >= 0.95;

  return (
    <Group
      justify="center"
      py={4}
      px="xs"
      style={{
        borderTop: '1px solid rgba(255, 255, 255, 0.06)',
        background: isCritical ? 'rgba(250, 82, 82, 0.12)' : 'rgba(250, 176, 5, 0.12)',
      }}
    >
      <Text size="xs" c={isCritical ? 'red' : 'orange'}>
        {status.line}
      </Text>
    </Group>
  );
}
